import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IFax } from "src/app/models/fax/fax";

@Component({
  selector: "app-fax-info-modal",
  templateUrl: "./fax-info-modal.component.html",
  styleUrls: ["./fax-info-modal.component.scss"],
})
export class FaxInfoModalComponent {
  @Input() isOpen = false;
  @Input() fax: IFax | null = null;

  @Output() close = new EventEmitter<void>();

  formatDate(dateTime?: string) {
    if (!dateTime) {
      return "";
    }

    const date = new Date(dateTime);

    const datePart = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    const timePart = date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

    return `${datePart}, ${timePart}`;
  }
}
